// extracted by mini-css-extract-plugin
export default {"errorBoundaryContainer":"StackErrorBoundary_errorBoundaryContainer__AC0y9"};